import * as Yup from 'yup';

export const CreateEditTransactionValidationSchema = () => {
    return Yup.object({
        transactionDate: Yup.date().required("A data da transação é obrigatória"),
        transactionType: Yup.number().required("A tipo de operação é obrigatória").moreThan(0),
        cryptoCurrencyId: Yup.string().required("A cripto moeda é obrigatória"),
        walletId: Yup.string().required("A carteira é obrigatória"),
        cryptoCurrencyQuantity: Yup.number().required("A quantida de cripto moeda é obrigatória").moreThan(0),
        fiatAmount: Yup.number().required("O valor em moeda fiduciária é obrigatório").moreThan(0),
        price: Yup.number().required("O preço da cripto moeda é obrigatório").moreThan(0)
    });
}